'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var key = exports.key = 'CG2016';

// List of endpoints used by Portal / WebComponents.
// When you update a site to use a new endpoint, record it here.
// Also record the address of the site (e.g. https://comgate.fi/supergolf/) if applicable.

// NOTE: Endpoint URL must end with a slash

// Local dev
// export const endpoint = 'http://localhost:56206/Cloud.svc/';
// export const endpoint = 'https://localhost:44301/Cloud.svc/'; // SSL
// export const endpoint = 'https://localhost:44369/Cloud.svc/'; // SSL
// export const endpoint = 'https://localhost:44339/Cloud.svc/'; // SSL
// export const endpoint = 'https://192.168.111.2:44369/Cloud.svc/'; // SSL


//
// Hilton
// varaamo.matkaverkko.fi
//

// Newest available
// export const endpoint = 'https://varaamo.matkaverkko.fi/Intres/WinresCloudService/production/Cloud.svc/';
// export const endpoint = 'https://varaamo.matkaverkko.fi/Intres/WinresCloudService/test/Cloud.svc/';

// Finnlines (they have a custom frontend, no Portal/WebComponents, but logging this here anyway)
// export const endpoint = 'https://varaamo.matkaverkko.fi/Intres/WinresCloudService/Finnlines-Production/Cloud.svc/';
// export const endpoint = 'https://varaamo.matkaverkko.fi/Intres/WinresCloudService/Finnlines-Test/Cloud.svc/';

// Oulu / Kymi
// http://www.oulukeskusvaraamo.fi/ & http://www.kymibooking.fi/
// export const endpoint = 'https://varaamo.matkaverkko.fi/Intres/WinresCloudService/3.7rest/Cloud.svc/';

// OK matkat
//export const endpoint = 'https://varaamo.nfc.fi/intres/WinresCloudService/1085/Cloud.svc/';


//
// DataCenter Finland (DCF)
// varaamo2.matkaverkko.fi
//

// Newest available

// export const endpoint = 'https://varaamo2.matkaverkko.fi/Intres/WinresCloudService/production/Cloud.svc/';
// export const endpoint = 'https://varaamo2.matkaverkko.fi/Intres/WinresCloudService/test/Cloud.svc/';
var endpoint = exports.endpoint = 'https://varaamo2.matkaverkko.fi/Intres/WinresCloudService/feature-test-7/Cloud.svc/';

// Portal (https://varaamo2.matkaverkko.fi/Portal/)
// Used by at least Kristina Cruises
// export const endpoint = 'https://varaamo2.matkaverkko.fi/Intres/WinresCloudService/v1.4/Cloud.svc/';

// Pori
// export const endpoint = 'https://intres.visitpori.fi/Intres/WinresCloudService/v1.11.4/Cloud.svc/';


//
// Varaamo4 (nickname?)
// varaamo4.matkaverkko.fi
//

// Kalajoki K&K
// export const endpoint = 'https://varaamo4.matkaverkko.fi/WinresCloudService/kalajoki/Cloud.svc/';


//
// Matkapojat
// varaamo.matkapojat.fi
//

// Newest available
// export const endpoint = 'https://varaamo.matkapojat.fi/intres/WinresCloudService/731/Cloud.svc/';

// Laivalomat KOULUTUS4
// export const endpoint = 'https://varaamo.matkapojat.fi/Intres/WinresCloudService/laivalomat/Cloud.svc/';

// Matkapojat (they have hotel capacity updating / matlue system. Laivalomat.)
// export const endpoint = 'https://varaamo.matkapojat.fi/intres/WinresCloudService/3.7rest/Cloud.svc/';

// Matkapojat Portal
// export const endpoint = 'https://varaamo.matkapojat.fi/intres/WinresCloudService/649/Cloud.svc/';


//
// Olympia
// varaamo.olympia.fi
//

// Olympia (they have MatLue 2.0)
// export const endpoint = 'https://varaamo.olympia.fi/Intres/WinresCloudService/3.4rest/Cloud.svc/';

// Omaloma
// export const endpoint = 'https://varaamo.olympia.fi/Intres/WinresCloudService/618/Cloud.svc/';


//
// Miscellaneous
// (various servers)
//

// Levi
// export const endpoint = 'https://varaamo.levi.fi/Intres/WinresCloudService/808/Cloud.svc/';

// Kymen matkat / kymi (they have WebComponents)
// export const endpoint = 'http://varaamo.kymenmatkat.fi/Intres/WinresCloudService/3.4rest/Cloud.svc/';

// Lahti Region (webcomponents for K&K / bottas)
// export const endpoint = 'http://shop.lahtitravel.fi/LahtiRegion/WinresCloudService/3.4rest/Cloud.svc/';

// Lehtimäki (they tried MatLue 2.0)

//export const endpoint = 'https://e-varaukset.lehtimaenmatkat.fi/intres/WinresCloudService/v1.18.9/Cloud.svc/';
//export const endpoint = 'https://e-varaukset.lehtimaenmatkat.fi/intres/WinresCloudService/v1.11.5/Cloud.svc/';
// export const endpoint = 'http://e-varaukset.lehtimaenmatkat.fi/intres/WinresCloudService/3.3rest/Cloud.svc/';

// OK-matkat (tried matlue)
// Portal: https://varaamo.nfc.fi/portal/
// export const endpoint = 'https://varaamo.nfc.fi/Intres/WinresCloudService/858/Cloud.svc/';

// Vekka (Tried matlue)
// export const endpoint = 'https://varaamo3.matkaverkko.fi/Intres/WinresCloudService/3.1rest/Cloud.svc/';

// Jyväskylä
// export const endpoint = 'http://online.jklpaviljonki.fi/intres/WinresCloudService/820/Cloud.svc/';

// Kokkolan matkatoimisto
//export const endpoint = 'https://booking.kokkolanmatkatoimisto.fi/intres/WinresCloudService/1089/cloud.svc/';


// Milliseconds reservation components caches destinations
var destinationCacheTimeMs = exports.destinationCacheTimeMs = 0;

var featureTestEndpoints = {};
// There are actually only 3 so far, but there's no harm in
// defining non-existent ones here, and that avoids needing
// to add more later.
for (var n = 1; n <= 10; ++n) {
    featureTestEndpoints['varaamo1-feature' + n] = 'https://varaamo.matkaverkko.fi/Intres/WinresCloudService/Feature-Test-' + n + '/Cloud.svc/';
    featureTestEndpoints['varaamo2-feature' + n] = 'https://varaamo2.matkaverkko.fi/Intres/WinresCloudService/Feature-Test-' + n + '/Cloud.svc/';
}

var otherEndpoints = {
    localhost: 'http://localhost:56206/Cloud.svc/',
    test: 'https://varaamo2.matkaverkko.fi/Intres/WinresCloudService/test/Cloud.svc/',
    varaamo1test: 'https://varaamo.matkaverkko.fi/Intres/WinresCloudService/test/Cloud.svc/',
    olympia: 'https://varaamo.olympia.fi/Intres/WinresCloudService/production/Cloud.svc/',
    kokkola: 'https://booking.kokkolanmatkatoimisto.fi/Intres/WinresCloudService/production/Cloud.svc/',
    production: 'https://varaamo2.matkaverkko.fi/Intres/WinresCloudService/production/Cloud.svc/'
};

// These endpoints are available by adding ?endpointOverride=localhost to the URL.
// The override can be removed by adding ?noEndpointOverride=true to the URL.
var endpointOverrides = exports.endpointOverrides = _.assign({}, featureTestEndpoints, otherEndpoints);

var passwordMinLength = exports.passwordMinLength = 6;

var overrideUIDefinitions = exports.overrideUIDefinitions = false; // Normal
//*/
/*
{ // For testing asiakaslista
    'UIControls': [
        { 'Code': 'asiakaslista' },
    ]
};
//*/
/* { // For testing Oma Loma
    'UIControls': [
        { 'Code': 'asiakastiedot' },
        { 'Code': 'omat-varaukset' },
        { 'Code': 'uusi-varaus' }
    ]
};
//*/
/*{ // For testing ABIristeilyt
    'UIControls': [
        { 'Code': 'ryhma-matkustajat' },
        { 'Code': 'ryhma-hytit' }
    ]
};
//*/


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 541
// module chunks = 2